import { render } from "./_Testing.vue?vue&type=template&id=76534bd3&scoped=true&lang=en"
import script from "./_Testing.vue?vue&type=script&lang=js"
export * from "./_Testing.vue?vue&type=script&lang=js"

import "./_Testing.vue?vue&type=style&index=0&id=76534bd3&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76534bd3"]])

export default __exports__